import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Result, Button, Typography } from 'antd';

const { Paragraph, Text } = Typography;

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  componentStack?: string;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({ componentStack: errorInfo.componentStack || undefined });
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      const { error, componentStack } = this.state;
      return (
        <div style={{ padding: '50px', textAlign: 'center' }}>
          <Result
            status="error"
            title="Qualcosa è andato storto"
            subTitle="Si è verificato un errore imprevisto. Prova a ricaricare la pagina."
            extra={
              <Button type="primary" onClick={this.handleReload}>
                Ricarica Pagina
              </Button>
            }
          >
            {error && (
              <div style={{ textAlign: 'left', maxWidth: 800, margin: '0 auto' }}>
                <Paragraph>
                  <Text strong>Dettaglio errore:</Text>
                </Paragraph>
                <Paragraph>
                  <Text code copyable style={{ whiteSpace: 'pre-wrap' }}>
                    {error.toString()}
                  </Text>
                </Paragraph>
                {(error.stack || componentStack) && (
                  <details>
                    <summary style={{ cursor: 'pointer', marginBottom: 8 }}>Stack trace</summary>
                    <pre style={{ fontSize: 11, whiteSpace: 'pre-wrap', background: '#fafafa', padding: 12, borderRadius: 4 }}>
                      {error.stack}
                      {componentStack}
                    </pre>
                  </details>
                )}
              </div>
            )}
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
